export enum PlaylistDialogMessagesEnum {
    ChangeActiveTabInfo = 'File uploading is in progress. If you leave the current tab the progress will be stopped.',
    PlaylistCreationTitle = 'Playlist creation',
    PlaylistDeletingTitle = 'Playlist deleting',
    DeletingPlaylistTitle = 'Deleting playlist',
    PlaylistDuplicationTitle = 'Playlist duplication',
    PlaylistItemDuplicationTitle = 'Playlist item duplication',
    PlaylistUpdatingTitle = 'Playlist updating',
    Playlisttitle = 'Playlist',
    PlaybackScheduleMessage = '. This playlist is set in the playback schedule.',
    PlaylistTypeChangingMessage = `You are about to modify the playlist for compatibility with Android devices.
      Please be aware that this change may impact your current playlist settings.`,
    PlaylistBackUpMessage = ` It\'s recommended to create a backup of your playlist before proceeding with the adjustments.`,
    PlaylistDismissingTitle = 'Dismissed successfully',
    PlaylistDismissingMessage = 'Playlist assignment was successfully dismissed',
    PlaylistCancelingTitle = 'Canceled successfully',
    PlaylistCancelingMessage = 'Playlist assignment was successfully canceled',
    PlaylistPPTConvertingMessage = 'Would you like to convert the PPT file to make it compatible with the MAW Chrome Launcher?',
    AndroidPlaylistPPTConvertingMessage = 'Would you like to convert the PPT file to make it compatible with the Andoroid playlist?',
    PlaylistMP4ToWebmConvertingMessage = 'Would you like to convert the MP4 file to the Webm to make it compatible with the MAW Chrome Launcher?',
    PlaylistMP4ToWebmConvertingTitle = 'Converting MP4 files to Webm...',
    PlaylistMP4ConvertingTitle = 'Converting MP4 file...'
}
